export default __webpack_public_path__ + "static/media/section2-img1.438463a0.png";